<template>
    <div style="overflow: hidden;" :style="{ width: width + 'px', height: height + 'px' }">
  
      <div style="position: relative;" :style="{ width: width + 'px', height: height + 'px' }">
        <div style="position: absolute; top: 0; left: 0; display: block; z-index: 4;" :style="{ width: width_video_user + 'px', height: height_video_user + 'px' }">
          <video ref="localVideo" autoplay muted style="width: 100%; height: 100%;"/>
        </div>
        <div style="position: absolute; top: 0; left: 0; display: block; z-index: 3;" :style="{ width: width + 'px', height: height + 'px' }">
          <video ref="remoteVideo" autoplay style="width: 100%; height: 100%;"/>
        </div>
        <button v-if="show_btn_start_call" @click="iniciarVideoDenuncia" style="position: relative; z-index: 6; top: 50%; left: 50%; transform: translate(-50%, -50%); background-color: #6d1d3e; color: white; border-radius: 0.4rem; padding: 0.5rem 1rem; font-size: 0.8rem; text-transform: uppercase; letter-spacing: 0.05rem;">Comenzar videollamada</button>
        <div v-if="waiting" style="position: relative; z-index: 6; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
          <div class="loader">
            <div class="bar1"></div>
            <div class="bar2"></div>
            <div class="bar3"></div>
            <div class="bar4"></div>
            <div class="bar5"></div>
            <div class="bar6"></div>
            <div class="bar7"></div>
            <div class="bar8"></div>
            <div class="bar9"></div>
            <div class="bar10"></div>
            <div class="bar11"></div>
            <div class="bar12"></div>
          </div>
        </div>
        <button v-if="!show_btn_start_call && !waiting" @click.prevent="destroyLocalVideo" style="position: absolute; z-index: 6; bottom: 0.5rem; left: 50%; transform: translateX(-50%) ; background-color: #ce3434; color: white; border-radius: 0.5rem; padding: 0.5rem 1rem; font-size: 0.8rem; text-transform: uppercase; letter-spacing: 0.05rem;">
          Finalizar
        </button>
      </div>
  
    </div>
  </template>
  
  <script>
    import Echo from "laravel-echo";
    import Pusher from "pusher-js";
    import Peer from "simple-peer";
    import axios from "axios";
    
    export default {

      name: "Streaming",
      
      props: ['field', 'formValues', 'tramite_id', 'width', 'height'],
      
      data() {
        return {
          waiting: false,
          show_btn_start_call: true,
          showBtnFinalizarLlamada: false,
          width_video_user: null,
          height_video_user: null
        };
      },

      mounted(){
        this.width_video_user = this.width;
        this.height_video_user = this.height;
      },

      methods: {
  
        async iniciarVideoDenuncia() {
          this.waiting = true;
          this.show_btn_start_call = false;
          await this.joinStreamChannel();
        },
    
        async getMediaStream() {
          try {
            const mediaStream = await navigator.mediaDevices.getUserMedia({
              video: true,
              audio: true,
            });
            this.$refs.localVideo.srcObject = mediaStream;
            return mediaStream;
          } catch (error) {
            throw new Error("No se pudo obtener la instancia UserMedia del emisor");
          }
        },
    
        getEchoInstance() {
          const client = new Pusher("06733f75bae2826bbfd6", {
            cluster: "us2",
            forceTLS: true,
            authEndpoint: 'https://api.denuncia.pgjhidalgo.gob.mx/api/streaming-fun',
            auth: {
                headers: {
                    'Accept': 'application/json',
                    'client-id': 'bestogob_web',
                    'Authorization': 'Basic YmVzdG9nb2Jfd2ViOmVmMzFkN2Y5Njc5NTM0YTFjNWI1ZGMxMjUwMGFmZGRkMTgxZDkyODU='
                }
            }
          });
          return new Echo({ broadcaster: "pusher", client: client });
        },
    
        getPeerInstance(localStream) {
          const iceConfiguration = [
            { urls: "stun:global.stun.twilio.com:3478" },
            {
              urls: "turn:global.turn.twilio.com:3478?transport=udp",
              username:
                "4fcb6dd90296d7aef5511160d94d2f700b37d723656722aa2f4fc61404dffe7a",
              credential:
                "tS8p/lthkUlF7k1Hedm4/qQdzBT93XDy+6tqPq2KUBw=",
            },
          ];
    
          return new Peer({ initiator: false, trickle: true, config: { iceServers: iceConfiguration }, stream: localStream });
        },
    
        async notificarVideollamada(tramite_id, signal) {
            const apiClient = axios.create({
                baseURL: "https://api.denuncia.pgjhidalgo.gob.mx/api/",
                timeout: 10000,
                headers: {
                    'Accept': 'application/json',
                    'client-id': 'bestogob_web',
                    'Authorization': `Bearer 5324|FjOYPjwsKyFutVKO4Wcnmp55Y6BDsT6fZGGISA7R`
                }
            });
    
          return apiClient.post("citizen/video/call-user", {
            user_to_call: tramite_id,
            signal: signal,
            from: tramite_id,
            tramiteId: tramite_id
          });
        },
    
        async notificarTransmision(tramite_id, nombre) {
          const backendClient = axios.create({
            baseURL: "https://agentes.pgjhidalgo.gob.mx/backend/api/",
            timeout: 10000,
            headers: { Accept: "application/json" },
          });
    
          return backendClient.get("start_streaming", {
            params: { t: tramite_id, name: nombre },
          });
        },
    
        async joinStreamChannel() {
          try {
            const mediaStream = await this.getMediaStream();
            const echo = this.getEchoInstance();
            const channel = echo.join(`video-channel.${this.tramite_id}`);
    
            await new Promise((resolve, reject) => {
              channel.here(() => resolve());
              channel.error((error) => reject(error));
            });
    
            channel.listen("StartVideoChat", async (data) => {
              if (data.data.type === "callAccepted") {
                const signalId = data.data.signal;
                const headers = {
                  Accept: "application/json",
                  "client-id": "bestogob_web",
                  Authorization:
                    `Basic YmVzdG9nb2Jfd2ViOmVmMzFkN2Y5Njc5NTM0YTFjNWI1ZGMxMjUwMGFmZGRkMTgxZDkyODU=`,
                };
    
                try {
                  const response = await axios.get(
                    `https://api.denuncia.pgjhidalgo.gob.mx/api/broadcast/${signalId}`,
                    { headers }
                  );
                  const signalData = response.data;
    
                  if (signalData && signalData.sdp) {
                    signalData.sdp += "\n";
                  }
    
                  const peer = this.getPeerInstance(mediaStream);
    
                  peer.on("signal", (signal) => {
                    this.notificarVideollamada(this.tramite_id, signal);
                  });
    
                  peer.signal(signalData);
    
                  peer.on("stream", (stream) => {
                    this.$refs.remoteVideo.srcObject = stream;
                    this.waiting = false;
                  });
    
                  peer.on("connect", () => {
                    this.waiting = false;
                    this.width_video_user = this.width / 2;
                    this.height_video_user = this.height / 2;
                  });
    
                  peer.on("close", () => {
                    peer.destroy();
                  });
    
                  peer.on("error", (err) => {
                    console.error("Peer connection error:", err);
                  });
                } catch (apiError) {
                  console.error("Error fetching signal data:", apiError);
                }
              }
            });
    
            const nombre_denunciante = `Daniel Tlanepantla Pantoja`;
            await this.notificarTransmision(this.tramite_id, nombre_denunciante);
          } catch (error) {
            console.error("Error joining presence channel:", error);
          }
        },
    
        destroyLocalVideo() {
          if (this.$refs.localVideo || this.$refs.remoteVideo) {
            this.$refs.localVideo.pause();
            this.$refs.remoteVideo.pause();
    
            const str = this.$refs.localVideo.srcObject;
            const str2 = this.$refs.remoteVideo.srcObject;
    
            if (str) {
              str.getTracks().forEach((track) => {
                track.stop();
              });
            }
    
            if (str2) {
              str2.getTracks().forEach((track) => {
                track.stop();
              });
            }
    
            this.$refs.localVideo.srcObject = null;
            this.$refs.remoteVideo.srcObject = null;
          }

          this.width_video_user = this.width;
          this.height_video_user = this.height;
          this.showBtnFinalizarLlamada = false
          this.show_btn_start_call = true;
          this.waiting = false;

        }
      },
    };
  </script>
  
<style scoped>
  .loader {
    position: relative;
    width: 54px;
    height: 54px;
    border-radius: 10px;
  }

  .loader div {
    width: 8%;
    height: 24%;
    background: rgb(128, 128, 128);
    position: absolute;
    left: 50%;
    top: 30%;
    opacity: 0;
    border-radius: 50px;
    box-shadow: 0 0 3px rgba(0,0,0,0.2);
    animation: fade458 1s linear infinite;
  }

  @keyframes fade458 {
    from {
      opacity: 1;
    }

    to {
      opacity: 0.25;
    }
  }

  .loader .bar1 {
    transform: rotate(0deg) translate(0, -130%);
    animation-delay: 0s;
  }

  .loader .bar2 {
    transform: rotate(30deg) translate(0, -130%);
    animation-delay: -1.1s;
  }

  .loader .bar3 {
    transform: rotate(60deg) translate(0, -130%);
    animation-delay: -1s;
  }

  .loader .bar4 {
    transform: rotate(90deg) translate(0, -130%);
    animation-delay: -0.9s;
  }

  .loader .bar5 {
    transform: rotate(120deg) translate(0, -130%);
    animation-delay: -0.8s;
  }

  .loader .bar6 {
    transform: rotate(150deg) translate(0, -130%);
    animation-delay: -0.7s;
  }

  .loader .bar7 {
    transform: rotate(180deg) translate(0, -130%);
    animation-delay: -0.6s;
  }

  .loader .bar8 {
    transform: rotate(210deg) translate(0, -130%);
    animation-delay: -0.5s;
  }

  .loader .bar9 {
    transform: rotate(240deg) translate(0, -130%);
    animation-delay: -0.4s;
  }

  .loader .bar10 {
    transform: rotate(270deg) translate(0, -130%);
    animation-delay: -0.3s;
  }

  .loader .bar11 {
    transform: rotate(300deg) translate(0, -130%);
    animation-delay: -0.2s;
  }

  .loader .bar12 {
    transform: rotate(330deg) translate(0, -130%);
    animation-delay: -0.1s;
  }
</style>